import Estimations, { MonthEstimation } from '../../domain/estimations/Estimations';
import { monthByNumber } from '../admin/getEstimationMonths';

export const calculateSeparatorForMonths = (estimations: Estimations): string[] => {
    let prevYear: number;
    return estimations.map((monthEstimation: MonthEstimation, index: number) => {
        let separator = '';
        const monthLabel: string = monthByNumber[monthEstimation.month.month];
        if (index !== 0 && index !== Object.keys(estimations).length) {
            separator = ', ';
        }
        if (prevYear !== monthEstimation.month.year && index !== 0) {
            separator = ' ' + prevYear + ', ';
        }

        const monthText = index === Object.keys(estimations).length - 1 ? monthLabel + ' ' + monthEstimation.month.year + '.' : monthLabel;
        prevYear = monthEstimation.month.year;
        return separator + monthText;
    });
};



// WEBPACK FOOTER //
// ./src/view/estimations/calculateSeparatorForMonths.ts